<ng-container *ngIf="compact; else detailed">
  <ng-container *ngFor="let part of parts; trackBy: trackPart">
    <span *ngIf="part.kind === 'source'; else text" class="qa-source-chip" [attr.title]="part.title">
      <span class="sr-only">{{part.text}}</span>
      <app-qa-dependency-source aria-hidden="true" [source]="part.source" [fallback]="part.text" [compact]="true"></app-qa-dependency-source>
    </span>
    <ng-template #text><span [class.qa-logic]="part.kind === 'join' || part.kind === 'bracket'">{{part.text}}</span></ng-template>
  </ng-container>
</ng-container>
<ng-template #detailed>
  <span class="sr-only">{{summary}}</span>
  <span aria-hidden="true" class="qa-summary-content">
    <ng-container *ngIf="group?.elements?.length; else empty">
      <ng-container *ngTemplateOutlet="node; context: {$implicit: group}"></ng-container>
    </ng-container>
    <ng-template #empty>{{summary}}</ng-template>
  </span>
</ng-template>

<ng-template #node let-current let-nested="nested">
  <span class="qa-summary-group" [class.qa-summary-nested]="nested">
    <span *ngIf="nested" class="qa-summary-mode">{{translate(current.operator === '||' ?
      'Mindestens eine Bedingung muss zutreffen' : 'Alle Bedingungen müssen zutreffen')}}</span>
    <ng-container *ngFor="let child of current.elements; let i = index">
      <span *ngIf="i" class="qa-summary-join">{{translate(current.operator === '||' ? 'ODER' : 'UND')}}</span>
      <ng-container *ngIf="child.type === 'group'; else rule">
        <ng-container *ngTemplateOutlet="node; context: {$implicit: child, nested: true}"></ng-container>
      </ng-container>
      <ng-template #rule>
        <span class="qa-summary-rule">
          <span class="qa-summary-chip">
            <i class="fa" [ngClass]="source(child)?.group === 'answers' ? 'fa-check-square-o' : 'fa-code'"></i>
            <app-qa-dependency-source [source]="source(child)"
              [fallback]="child.variable || translate('Frage oder Variable wählen')"></app-qa-dependency-source>
          </span>
          <span class="qa-summary-comparison">{{comparison(child)}}</span>
        </span>
      </ng-template>
    </ng-container>
  </span>
</ng-template>
